import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";

// constants
import { CDN_BASE_IMAGES_URL } from "@constant";

// files
import NoImgIcon from "../../../assets/icons/NoImg.svg";
import LogoutIcon from "../../../assets/icons/Logout.svg";

const Navbar = (props) => {
  const {
    // state
    eventData,

    // component
    logout = () => {},
  } = props;

  const eventIcon = `${CDN_BASE_IMAGES_URL}/${eventData?.eventicon}`;

  return (
    <section className="h-reviewerNav w-full flex justify-between items-center p-3 bg-white border-b- shadow-xl">
      {/* ----- Event logo - name ----- */}
      <div className="flex items-center gap-3">
        <div className="h-12 w-12">
          <img
            className="inline-block h-full w-full rounded"
            src={eventIcon}
            alt="eventicon"
            loading="lazy"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = NoImgIcon;
            }}
          />
        </div>

        <label className="text-2xl font-semibold">
          {eventData?.eventname ?? ""}
        </label>
      </div>

      {/* ----- Logout button ----- */}
      <div className="">
        <img
          src={LogoutIcon}
          className="cursor-pointer"
          alt="logout"
          onClick={logout}
        />
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    eventData: state.eventData,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
